import BaseService from '_services/rest/base';

class ProductService extends BaseService {
  constructor() {
    super();
  }

  deleteOption(id) {
    return this.request(`${this.getUrl()}/type/option/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  deleteProduct(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  deleteSupplier(id) {
    return this.request(`${this.getUrl()}/supplier/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  deleteType(productId, id) {
    return this.request(`${this.getUrl()}/${productId}/type/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  deleteVariation(id) {
    return this.request(`${this.getUrl()}/variations/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  getUrl() {
    return `${super.getUrl()}api/product`;
  }

  getUrlSave(id, url) {
    if (id) {
      return {
        url: `${this.getUrl()}${url}/${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}${url}`,
      method: 'POST',
    };
  }

  getList(params) {
    const filters = { search: params.search };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getVariationsList(params) {
    return this.request(`${this.getUrl()}/${params.id}/variations/${params.skip}/${params.take}`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getTypesList(id) {
    return this.request(`${this.getUrl()}/${id}/type/all`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getProductById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getProductUnits() {
    return this.request(`${this.getUrl()}/units`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getProductVariations(search) {
    return this.request(`${this.getUrl()}/variations/all`, search)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getProductFilters() {
    return this.request(`${this.getUrl()}/variations/prices/filter`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getproductVariationsPriceExport(params) {
    const filters = { search: params.search, productId: params.productId };
    return this.request(`${this.getUrl()}/variations/prices/export`, filters)
      .catch(err => {
        throw err;
      });
  }

  getproductVariationsPriceList(params) {
    const filters = { search: params.search, productId: params.productId };
    return this.request(`${this.getUrl()}/variations/prices/${params.skip}/${params.take}`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  save(product) {
    const meta = this.getUrlSave(product.id, '');
    return this.request(meta.url, product, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveVariationType(type, productId) {
    const meta = this.getUrlSave(type.id, `/${productId}type`);
    return this.request(meta.url, type, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveNewVariationTypeOption(option, productId, typeId) {
    return this.request(`${this.getUrl()}/${productId}/type/${typeId}/option`, option, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveVariationTypeOption(option) {
    return this.request(`${this.getUrl()}/type/option/${option.id}`, option, 'PUT')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  uploadFile(file) {
    const formData = new FormData();
    formData.append('file', file);
    return this.request(`${super.getUrl()}api/file/products`, formData, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  updatePrice(variation) {
    return this.request(`${this.getUrl()}/variations/${variation.id}/price`, { price: variation.price }, 'PUT')
      .catch(err => {
        throw err;
      });
  }

  updateVariation(variation) {
    return this.request(`${this.getUrl()}/variations/${variation.id}`, variation, 'PUT')
      .catch(err => {
        throw err;
      });
  }
}

export default new ProductService();
